module.exports = __webpack_public_path__ + "img/bf-hero-desktop.968df069.jpg";